/* eslint-disable no-mixed-operators */
/* eslint-disable no-param-reassign */
/* eslint-disable no-nested-ternary */
import React, { Component } from 'react';
import { flushSync } from 'react-dom';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fal } from '@fortawesome/pro-light-svg-icons';
import { far } from '@fortawesome/pro-regular-svg-icons';
import { fas } from '@fortawesome/pro-solid-svg-icons';
import _ from 'lodash';
import CryptoAES from 'crypto-js/aes';
import CryptoEnc from 'crypto-js/enc-utf8';
import { Route, Routes } from 'react-router';
import config from './config';
import Auth0SessionInfo from 'Services/Auth0SessionInfo';
import CDATA from 'Services/CDATA';
import permissionsApi from 'Services/permissionsApi';
import ModalClientSelection from 'Layouts/ModalClientSelection';
import Outbound from 'Layouts/Routing/Outbound';
import Inbound from 'Layouts/Routing/Inbound';
import AppContext from './AppContext';
import { setLivePermissions } from './Components/Auth0/permissionFunctions';
import GrpNavItem from './Library/GrpNavItem/GrpNavItem';
import classes from './App.module.scss';
import HomeAside from './Components/HomeAside/HomeAside';
import HomeDrawer from './Components/HomeDrawer/HomeDrawer';
import { DrawerDateSelect } from './Components/HomeDrawer/HomeDrawer.styles';
import {
  AppError, AppModal, ClientReportingDrawer, HomeScreenHeader, LoadingSpinner, LogoutButton,
  Toaster,
} from './App.styles';
import ClientButton from './Components/HomeDrawer/DrawerSelection/ClientButton';
// import HomeContextPanel from './Components/HomeContextPanel/HomeContextPanel';
import HomeContent from './Components/HomeContent/HomeContent';
import Callback from './Views/Auth0/Callback';
import Auth0IdleTimer from './Components/Auth0/Auth0IdleTimer';

const { encKey } = config.sessionStorage;
const SHARD_MANAGEMENT_LABEL = 'Manage Shards';
const SHARD_MANAGEMENT_FALLBACK_PATH = '/admin/shard-management';
const SUPER_USER_PERMISSION_MARKERS = new Set([
  'admin/manage-roles/manage-hidden-roles',
  'admin/shard-management',
  'admin/shard-management/view'
]);

const normalizePath = (pathValue = '') => {
  const prefixed = pathValue.startsWith('/') ? pathValue : `/${pathValue}`;
  return prefixed.replace(/\/+/g, '/');
};

const OUTBOUND_MODULES = new Set(['overview', 'distribution']);
const isOutboundModule = (moduleName = '') => OUTBOUND_MODULES.has(moduleName.toLowerCase());

class App extends Component {
  authClient

  interval

  // Aside state kept outside React state to avoid full-tree context re-renders on toggle
  _asideOpen = false;
  _cachedContextValue = null;
  _cachedState = null;

  constructor(props) {
    super(props);

    library.add(fal, fas, far);
    this.authClient = props.authClient;
    this.interval = props.interval;
    let callbackURL = window.localStorage.getItem("callbackURL") || "/";
    window.localStorage.removeItem("callbackURL");

    const sessionAppState = sessionStorage.getItem('AppStateStorage');
    const { user } = Auth0SessionInfo.GetSessionInfo();
    if (sessionAppState) {
      this.state = JSON.parse(
        CryptoAES.decrypt(sessionAppState.toString(), encKey).toString(CryptoEnc),
      );
      // Restore aside state from session (kept outside React state)
      this._asideOpen = this.state.asideOpen || false;
      this.state.drawerContent = null;
      this.state.drawerOpen = false;
      this.state.toast = null;
      this.state.modalContent = null;
      this.state.modalFooter = null;
      this.state.modalOpen = false;
      this.state.loading = false;
      this.state.failed = false;
      this.state.failMessage = null;
      this.state.user = user;
      this.state.userEmail = user.email;
      this.state.callbackURL = callbackURL;
      this.state.calledBack = false;

      const shardAccess = this.resolveShardManagementAccess({
        selectedLayout: this.state.selectedLayout || [],
        availableRoutes: this.state.availableRoutes || [],
        permissions: this.state.permissions || [],
      });

      // Recompute computedMenuItems if missing (stale session or first load after deploy)
      this.state.availableModules = this.ensureShardManagementModule(this.state.availableModules || [], shardAccess);
      if (this.state.availableModules && !this.state.computedMenuItems && this.state.selectedLayout) {
        this.state.computedMenuItems = this.state.availableModules.reduce((acc, mod) => {
          acc[mod.module] = _.uniqBy(
            this.state.selectedLayout
              .filter((item) => item.module === mod.module && item.level_display_name !== null)
              .map((y) => ({
                path: `/${y.module}/${y.level}`,
                display: y.level_display_name,
              })),
            'path',
          );
          return acc;
        }, {});
      }

      this.state.computedMenuItems = this.ensureManageShardsMenuItem(this.state.computedMenuItems || {}, shardAccess);
      this.state.availableRoutes = this.ensureShardManagementRoute(this.state.availableRoutes || [], shardAccess);
      this.state.permissions = this.ensureShardManagementPermissions(this.state.permissions || [], shardAccess);
    } else {
      this.state = {
        loading: true,
        failed: false,
        failMessage: null,
        showClientSelection: false,

        userAzureID: null,
        userDisplayName: null,
        userGivenName: null,
        userSurname: null,
        userEmail: user.email,

        availableClientCodeAndNames: null,
        availableReportingDates: null,
        availableLayout: null,
        availableRoutes: null,
        availableModules: null,
        availableLevels: null,
        availableSubLevels: null,
        availableFunds: null,
        availableClasses: null,

        selectedClient: null, // code, name, type
        selectedReportingDate: null,
        selectedRegulation: null,
        selectedLayout: null,

        contextPanelOpen: false,
        drawerOpen: false,
        drawerContent: null,
        toast: null,

        modalOpen: false,
        modalTitle: null,
        modalContent: null,
        modalContentOverflow: null,
        modalFooter: null,
        modalSpinner: false,
        callbackURL: callbackURL,
        calledBack: false,
      };
    }
    this.handlers = {
      handleClientSelect: this.handleClientSelect,
      handleDateSelect: this.handleDateSelect,
      // toggleAsideState: this.toggleAsideState,
      // toggleContextPanel: this.toggleContextPanel,
      toggleDrawer: this.toggleDrawer,
      // toggleSubPanel: this.toggleSubPanel,
      // getCards: this.getCards,

      setSelectedClient: this.setSelectedClient,
      setSelectedReportingDate: this.setSelectedReportingDate,
      setSelectedRegulation: this.setSelectedRegulation,
      setAvailableLevels: this.setAvailableLevels,
      setAvailableSubLevels: this.setAvailableSubLevels,

      toggleAside: this.toggleAside,
      setDrawerContent: this.setDrawerContent,

      setToast: this.setToast,
      closeToast: this.closeToast,
      setModal: this.setModal,
      toggleModal: this.toggleModal,
      injectClientReportingIntoDrawer: this.injectClientReportingIntoDrawer,
      closeModal: this.closeModal,
      openModal: this.openModal,
      toggleClientSelection: this.toggleClientSelection,
    };
  }

  isSuperUser(permissions = []) {
    if (!Array.isArray(permissions)) {
      return false;
    }

    return permissions.some((permission) => SUPER_USER_PERMISSION_MARKERS.has(permission));
  }

  getShardManagementPathFromLayout(selectedLayout = []) {
    if (!Array.isArray(selectedLayout)) {
      return null;
    }

    const routeFromLayout = selectedLayout.find((item) => (
      item?.component === 'ShardManagement'
      || item?.level === 'shard-management'
      || item?.sublevel === 'shard-management'
    ));

    if (!routeFromLayout) {
      return null;
    }

    if (routeFromLayout.level && routeFromLayout.sublevel) {
      return normalizePath(`${routeFromLayout.module}/${routeFromLayout.level}/${routeFromLayout.sublevel}`);
    }

    if (routeFromLayout.level) {
      return normalizePath(`${routeFromLayout.module}/${routeFromLayout.level}`);
    }

    return normalizePath(routeFromLayout.module || '');
  }

  getShardManagementPathFromRoutes(availableRoutes = []) {
    if (!Array.isArray(availableRoutes)) {
      return null;
    }

    const route = availableRoutes.find((routeItem) => (
      routeItem?.component === 'ShardManagement'
      || routeItem?.full_path?.includes('/shard-management')
    ));

    return route?.full_path || null;
  }

  getShardManagementPathFromPermissions(permissions = []) {
    if (!Array.isArray(permissions)) {
      return null;
    }

    const permission = permissions.find((permissionName) => (
      typeof permissionName === 'string' && permissionName.includes('shard-management')
    ));

    if (!permission) {
      return null;
    }

    const segments = permission.replace(/^\/+/, '').split('/');
    const shardManagementIndex = segments.indexOf('shard-management');

    if (shardManagementIndex <= 0) {
      return null;
    }

    return normalizePath(segments.slice(0, shardManagementIndex + 1).join('/'));
  }

  resolveShardManagementAccess({ selectedLayout = [], availableRoutes = [], permissions = [] } = {}) {
    const routeFromLayout = this.getShardManagementPathFromLayout(selectedLayout);
    const routeFromRoutes = this.getShardManagementPathFromRoutes(availableRoutes);
    const routeFromPermissions = this.getShardManagementPathFromPermissions(permissions);
    const isSuperUser = this.isSuperUser(permissions);

    const hasShardManagementAccess = Boolean(
      routeFromLayout || routeFromRoutes || routeFromPermissions || isSuperUser,
    );
    const path = hasShardManagementAccess ? SHARD_MANAGEMENT_FALLBACK_PATH : null;
    const hasAdminShardPermission = Array.isArray(permissions)
      && permissions.some((permission) => typeof permission === 'string' && permission.startsWith('admin/shard-management'));

    return {
      path,
      module: path ? path.split('/')[1] : null,
      shouldInjectFallbackPermissions: Boolean(path) && !hasAdminShardPermission,
    };
  }

  getShardManagementPermissionRules(path = '') {
    const normalizedPath = path.replace(/^\/+/, '');

    if (!normalizedPath) {
      return [];
    }

    return [
      normalizedPath,
      `${normalizedPath}/view`,
      `${normalizedPath}/add`,
      `${normalizedPath}/edit`,
      `${normalizedPath}/delete`
    ];
  }

  ensureShardManagementPermissions(permissions = [], shardAccess = {}) {
    if (!Array.isArray(permissions)) {
      return permissions;
    }

    if (!shardAccess.shouldInjectFallbackPermissions || !shardAccess.path) {
      return permissions;
    }

    return [...new Set([...permissions, ...this.getShardManagementPermissionRules(shardAccess.path)])];
  }

  ensureShardManagementModule(availableModules = [], shardAccess = {}) {
    if (!Array.isArray(availableModules) || !shardAccess.path || !shardAccess.module) {
      return availableModules;
    }

    const hasModule = availableModules.some((moduleItem) => moduleItem.module === shardAccess.module);
    if (hasModule) {
      return availableModules;
    }

    const moduleDisplayName = shardAccess.module === 'admin'
      ? 'Administration'
      : _.startCase(shardAccess.module);

    return [
      ...availableModules,
      {
        module: shardAccess.module,
        moduleDisplayName,
        icon: 'cog',
      },
    ];
  }

  ensureManageShardsMenuItem(computedMenuItems = {}, shardAccess = {}) {
    if (!shardAccess.path || !shardAccess.module) {
      return computedMenuItems;
    }

    const sanitizedMenuItems = Object.entries(computedMenuItems).reduce((acc, [moduleName, items]) => {
      acc[moduleName] = (items || []).filter((item) => (
        !item?.path?.includes('/shard-management') || item.path === shardAccess.path
      ));
      return acc;
    }, {});

    const moduleItems = sanitizedMenuItems[shardAccess.module] || [];
    const alreadyExists = moduleItems.some((item) => item.path === shardAccess.path);

    if (alreadyExists) {
      return sanitizedMenuItems;
    }

    return {
      ...sanitizedMenuItems,
      [shardAccess.module]: _.uniqBy(
        [...moduleItems, { path: shardAccess.path, display: SHARD_MANAGEMENT_LABEL }],
        'path',
      ),
    };
  }

  ensureShardManagementRoute(availableRoutes = [], shardAccess = {}) {
    if (!Array.isArray(availableRoutes)) {
      return availableRoutes;
    }

    if (!shardAccess.path) {
      return availableRoutes;
    }

    const alreadyExists = availableRoutes.some((route) => route.full_path === shardAccess.path);
    if (alreadyExists) {
      return availableRoutes;
    }

    return [
      ...availableRoutes,
      {
        full_path: shardAccess.path,
        component: 'ShardManagement',
        api_name: null,
        pk: null,
        exact: false,
        editable: false,
        force_reportingdate: false,
      },
    ];
  }

  componentDidMount() {
    this.getUserClientData().then(async () => {
      await this.setUserAzureID();
      if (this.state.availableClientCodeAndNames && this.state.availableClientCodeAndNames?.length === 1) {
        await this.setSelectedClient(this.state.availableClientCodeAndNames[0]);
      }
      if (this.state.selectedClient && !this.state.availableReportingDates) {
        // Session restored a selected client but reporting dates were not persisted
        // (debounced write may have fired before the API call completed). Re-fetch them.
        await this.fetchReportingDates(this.state.selectedClient.code);
      }
      await this.setStateAndSession({ loading: false });
    })
      .catch(async (error) => {
        // eslint-disable-next-line no-console
        console.log(error);
        await this.setStateAndSession({
          loading: false,
          failed: true,
          failMessage: error?.human || error?.message || 'Error initializing application.',
        });
      });
  }

  async setUserAzureID() {
    const setUserFromToken = async () => {
      const { user } = Auth0SessionInfo.GetSessionInfo();
      await this.setStateAndSession({
        userAzureID: user?.sub || null,
        userGivenName: user?.given_name || user?.name || '',
        userSurname: user?.family_name || '',
        userId: null,
      });
    };

    try {
      // the get user function fails if the token has expired so we get the token just in case
      const { user } = Auth0SessionInfo.GetSessionInfo();
      const safeRequest = async (method, endpoint, query, body, failMessage) => {
        try {
          return await CDATA.makeRequest(method, endpoint, query, body, failMessage);
        } catch (e) {
          // eslint-disable-next-line no-console
          console.warn('User metadata request failed:', endpoint, e?.message || e);
          return null;
        }
      };

      // Check if the Auth0 externalId is present in the users table.
      let data = await safeRequest(
        'GET',
        'PRIIPS_global_users',
        CDATA.addFilter(`externalId eq '${user.sub}'`),
        {},
        'Error looking up user ID. Please contact your administrator.',
      );

      if (!data?.value?.length) {
        // Set the Auth0 externalId for the record matching this email address.
        await safeRequest(
          'POST',
          'PRIIPS_global_UPDATE_USER_EXTERNAL_ID',
          '',
          {
            mail: user.email,
            externalId: user.sub,
          },
          'Error looking up user ID. Please contact your administrator.',
        );

        // Re-poll to get user record.
        data = await safeRequest(
          'GET',
          'PRIIPS_global_users',
          CDATA.addFilter(`externalId eq '${user.sub}'`),
          {},
          'Error looking up user ID. Please contact your administrator.',
        );
      }

      // Dev fallback: if the externalId mapping is still missing, attempt lookup by email.
      if (!data?.value?.length && user?.email) {
        data = await safeRequest(
          'GET',
          'PRIIPS_global_users',
          CDATA.addFilter(`mail eq '${user.email}'`),
          {},
          'Error looking up user ID. Please contact your administrator.',
        );
      }

      if (!data?.value?.length) {
        // Don't block app initialization in dev/sandbox when user table isn't seeded yet.
        await setUserFromToken();
        return;
      }

      const currentUser = data.value[0];

      // Capture the AzureID to state.
      await this.setStateAndSession({
        userAzureID: currentUser.azure_id || user?.sub || null,
        userGivenName: currentUser.FirstName || user?.given_name || user?.name || '',
        userSurname: currentUser.LastName || user?.family_name || '',
        userId: currentUser.RECORD_ID || null,
      });
      this.persistToSession.flush();
    } catch (err) {
      // In dev/sandbox, don't block app startup when user metadata lookup is unavailable.
      // eslint-disable-next-line no-console
      console.warn('Falling back to Auth0 token user metadata:', err?.message || err);
      await setUserFromToken();
    }
  }

  async getLayouts() {
    try {
      const data = await CDATA.makeRequest(
        'GET',
        'PRIIPS_metadata_route_display',
        `${CDATA.addFilter('is_active eq \'Y\'')}&${CDATA.addOrderBy('display_order asc')}`,
        {},
        'Error loading app layout. Please contact your administrator.',
      );
      await this.setStateAndSession({
        availableLayout: (data?.value || []).filter((item) => item.return_value !== '0'),
      });
    } catch (err) {
      // In dev/sandbox, don't block startup if metadata route endpoint is unavailable.
      // eslint-disable-next-line no-console
      console.warn('Falling back to empty layout metadata:', err?.message || err);
      await this.setStateAndSession({
        availableLayout: this.state.availableLayout || [],
      });
    }
  }

  async getUserClientData() {
    try {
      const auth0Session = Auth0SessionInfo.GetSessionInfo();
      const { accessToken } = auth0Session;
      const { user } = auth0Session;
      const data = await permissionsApi.getUserClients(user.email, accessToken);

      const filteredData = data.clients
        .filter((item) => item.id !== '0')
        .sort((a, b) => (a.name > b.name ? 1 : a.name < b.name ? -1 : 0));

      const clientDropdownObject = filteredData.map((x) => ({
        code: x.location,
        name: x.name,
        type: x.cli_type,
      }));
      await this.setStateAndSession({
        availableClientCodeAndNames: _.uniqBy(clientDropdownObject, 'code'),
      });
    } catch (err) {
      await this.setStateAndSession({
        loading: false,
        failed: true,
        failMessage: err.human || err.message,
      });
      throw err;
    }
  }

  setSelectedClient = async (clientSelectionArray) => {
    if (!this.state.selectedClient || clientSelectionArray.code !== this.state.selectedClient.code) { // if no selected client or selection doesn't equal
      await this.setStateAndSession(
        (prevState) => ({
          selectedClient: {
            code: clientSelectionArray.code,
            name: clientSelectionArray.name,
            type: clientSelectionArray.type,
          },
          showClientSelection: false,
          selectedReportingDate: null,
          availableFunds: null,
          availableClasses: null,
        }),
      )
      .then(async () => {
        this.setStateAndSession({
          loading: true,
        });
        // Flush session persistence immediately so that CDATA requests
        // pick up the selectedClient via the client_code header.
        this.persistToSession.flush();
        await this.getLayouts();
        const filteredLayout = this.state.availableLayout
          .filter((item) => item.cli_type === clientSelectionArray.type);

        const baseAvailableModules = _.uniqBy(
          filteredLayout.map((x) => ({
            module: x.module,
            moduleDisplayName: x.module_display_name,
            icon: x.module_icon,
          })),
          'module',
        );
        const baseComputedMenuItems = baseAvailableModules.reduce((acc, mod) => {
          acc[mod.module] = _.uniqBy(
            filteredLayout
              .filter((item) => item.module === mod.module && item.level_display_name !== null)
              .map((y) => ({
                path: `/${y.module}/${y.level}`,
                display: y.level_display_name,
              })),
            'path',
          );
          return acc;
        }, {});
        const baseAvailableRoutes = _.uniqBy(
          filteredLayout.map((x) => ({
            full_path: `/${x.module}${x.level !== null ? `/${x.level}` : ''}${x.sublevel !== null ? `/${x.sublevel}` : ''}`,
            component: x.component,
            api_name: x.api_name,
            pk: x.pk,
            exact: x.exact,
            editable: x.editable,
            force_reportingdate: x.force_reportingdate,
          })),
          'full_path',
        );

        // Set reporting dates for this client.
        const reportingDates = await CDATA.makeRequest(
          'GET',
          'PRIIPS_app_client_reporting_period',
          `${CDATA.addFilter(`ClientCode_bk eq '${clientSelectionArray.code}'`)}&${CDATA.addOrderBy('Reporting_Period DESC')}`,
          {},
          'Unable to load client reporting periods.',
        );
        const availableReportingDates = reportingDates.value.map((x) => ({
          code: x.Reporting_Period ? x.Reporting_Period.substring(0, 10) : null,
          name: x.Reporting_Period ? x.Reporting_Period.substring(0, 10) : null,
          selected: false,
        }));

        const auth0Session = Auth0SessionInfo.GetSessionInfo();
        const { accessToken } = auth0Session;
        const { user } = auth0Session;

        // Set permissions for this user and client.
        const permissionsData = await permissionsApi.getUserAppPermissions(
          user.email,
          this.state.selectedClient.code, accessToken,
        );
        const basePermissions = permissionsData.map((x) => x.appPermissionName);
        const shardAccess = this.resolveShardManagementAccess({
          selectedLayout: filteredLayout,
          availableRoutes: baseAvailableRoutes,
          permissions: basePermissions,
        });

        const availableModules = this.ensureShardManagementModule(baseAvailableModules, shardAccess);
        const computedMenuItems = this.ensureManageShardsMenuItem(baseComputedMenuItems, shardAccess);
        const availableRoutes = this.ensureShardManagementRoute(baseAvailableRoutes, shardAccess);
        const permissions = this.ensureShardManagementPermissions(basePermissions, shardAccess);

        // Set loading false only after critical data (dates + permissions) is ready.
        await this.setStateAndSession({
          availableModules,
          computedMenuItems,
          availableRoutes,
          selectedLayout: filteredLayout,
          availableReportingDates,
          permissions,
          loading: false,
        });
        if (window.location.search.includes("callback")) {
          this.setStateAndSession({ calledBack: true });
        }
        // get and store all the funds for this client if it's not insurance
        if (clientSelectionArray.type === 'AM') {
          try {
            const funds = await CDATA.makeRequest(
              'GET',
              'PRIIPS_app_fund',
              `${CDATA.addSelect('ClientCode_bk,FundCode_bk,Fund_Name')}&${CDATA.addFilter(`ClientCode_bk eq '${clientSelectionArray.code}'`)}`,
              {},
              'Error retrieving list of funds for the selected client',
            );
            const filteredFunds = funds.value.filter((item) => item.return_value !== '0');
            const availableFunds = filteredFunds.map((x) => (
              {
                value: x.FundCode_bk,
                label: `${x.Fund_Name} - ${x.FundCode_bk}`,
              }
            ));
            this.setStateAndSession({ availableFunds });

            const cliClasses = await CDATA.makeRequest(
              'GET',
              'PRIIPS_app_class',
              `${CDATA.addSelect('ClientCode_bk,ClassCode_bk,OF_Full_Share_Class_Name')}&${CDATA.addFilter(`ClientCode_bk eq '${clientSelectionArray.code}'`)}`,
              {},
              'Error retrieving list of classes for the selected client',
            );
            const filteredClasses = cliClasses.value.filter((item) => item.return_value !== '0');
            const availableClasses = filteredClasses.map((x) => ({
              value: x.ClassCode_bk,
              label: `${x.OF_Full_Share_Class_Name} - ${x.ClassCode_bk}`,
            }));
            this.setStateAndSession({ availableClasses });
          } catch (err) {
            // eslint-disable-next-line no-console
            console.log(err); // console.log(err.human)
          }
        }
      });
    } else {
      this.setStateAndSession({ showClientSelection: false });
    }
  }

  setSelectedReportingDate = (reportingDate) => {
    return this.setStateAndSession({ selectedReportingDate: reportingDate })
      .then(() => {
        this.closeDrawer();
      });
  }

  setSelectedRegulation = (regulation) => {
    this.setStateAndSession({ selectedRegulation: regulation });
  }

  setAvailableLevels = (moduleName) => {
    const interimLevels = this.state.selectedLayout
      .filter((item) => (item.module === moduleName && item.level !== null))
      .map((x) => ({
        path: x.level,
        display_name: x.level_display_name,
        display_order: x.display_order,
      }));
    const levels = _.uniqBy(interimLevels, 'path');
    this.setStateAndSession({ availableLevels: levels });
  }

  setAvailableSubLevels = (moduleName, level) => {
    const interimSubLevels = this.state.selectedLayout
      .filter((item) => (
        item.module === moduleName && item.level === level && item.sublevel !== null
      ))
      .map((x) => ({
        path: x.sublevel,
        display_name: x.sublevel_display_name,
        api_name: x.api_name,
        pk: x.pk,
        display_order: x.display_order,
        parent: x.level,
        component: x.component,
      }));
    const subLevels = _.uniqBy(interimSubLevels, 'path');
    this.setStateAndSession({ availableSubLevels: subLevels });
  }

  getAvailableReportingDates = async (clientCode) => {
    const reportingDates = await CDATA.makeRequest(
      'GET',
      'PRIIPS_app_client_reporting_period',
      `${CDATA.addFilter(`ClientCode_bk eq '${clientCode}'`)}&${CDATA.addOrderBy('Reporting_Period DESC')}`,
      {},
      'Unable to load client reporting periods.',
    );

    return reportingDates.value.map((x) => ({
      code: x.Reporting_Period ? x.Reporting_Period.substring(0, 10) : null,
      name: x.Reporting_Period ? x.Reporting_Period.substring(0, 10) : null,
      selected: false,
    }));
  }

  fetchReportingDates = async (clientCode) => {
    try {
      const availableReportingDates = await this.getAvailableReportingDates(clientCode);
      await this.setStateAndSession({ availableReportingDates });
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('Failed to fetch reporting dates:', e);
    }
  }

  toggleClientSelection = () => {
    this.setStateImmediate((prevState) => ({
      showClientSelection: !prevState.showClientSelection,
    }));
  };

  toggleAside = () => {
    this._asideOpen = !this._asideOpen;
    this.persistToSession();
    this.forceUpdate();
  };

  closeDrawer = () => {
    this.setStateImmediate({
      drawerContent: null,
      drawerOpen: false,
    });
  };

  toggleDrawer = () => {
    this.setStateImmediate((prevState) => ({
      drawerOpen: !prevState.drawerOpen,
      // if drawer was open then clear it out, otherwise let the content live
      drawerContent: prevState.drawerOpen === true ? null : prevState.drawerContent,
    }));
  };

  setToast = (toast) => {
    this.setStateImmediate({ toast });
  };

  closeToast = () => {
    const toast = { ...this.state.toast };
    toast.body = null;
    this.setStateImmediate({ toast });
  };

  setModal = (
    modalTitle, modalContent, modalContentOverflow, modalFooter, modalSpinner, modalWidth
  ) => {
    // eslint-disable-next-line no-param-reassign
    if (modalWidth === null) modalWidth = '400px';
    this.setStateImmediate({
      modalTitle, modalContent, modalContentOverflow, modalFooter, modalSpinner, modalWidth,
    });
  };

  toggleModal = () => {
    this.setStateImmediate(
      (prevState) => ({ modalOpen: !prevState.modalOpen }),
    );
  };

  closeModal = () => {
    this.setStateImmediate({ modalOpen: false });
  };

  openModal = () => {
    this.setStateImmediate({ modalOpen: true });
  };

  handleLogout = () => {
    sessionStorage.clear();
    window.localStorage.removeItem("callbackURL");
    this.authClient.logout({ logoutParams: { returnTo: config.auth0.logoutRedirectUrl } });
  }

  setDrawerContent = (drawerTitle, drawerContent) => {
    // Default to Client Reporting Date for drawer
    const clientDrawerTitle = 'Application Settings';

    const clientReportingDrawerContent = (
      <ClientReportingDrawer>
        {/* <DrawerClientSelect panelHeight="300px" /> */}
        <ClientButton />
        <DrawerDateSelect />
        <LogoutButton
          onClick={this.handleLogout}
          size="Medium"
          text="Logout"
          type="Primary"
        />
      </ClientReportingDrawer>
    );

    if (!drawerContent) {
      drawerContent = clientReportingDrawerContent;
      drawerTitle = clientDrawerTitle;
    }

    this.setStateImmediate({ drawerContent, drawerTitle, drawerOpen: true });
  }

  injectClientReportingIntoDrawer = () => {
    const drawerTitle = 'Application Settings';
    const drawerContent = (
      <ClientReportingDrawer>
        {/* <DrawerClientSelect panelHeight="300px" /> */}
        <ClientButton />
        <DrawerDateSelect />
        <LogoutButton
          onClick={this.handleLogout}
          size="Medium"
          text="Logout"
          type="Primary"
        />
      </ClientReportingDrawer>
    );
    // this.setDrawerContent(drawerContent);
    this.setStateImmediate({ drawerTitle, drawerContent, drawerOpen: true });
  };

  // Debounced persistence to sessionStorage — runs only when browser is idle
  // to avoid blocking renders with JSON.stringify + AES encryption
  persistToSession = _.debounce(() => {
    const doEncrypt = () => {
      const stateToSave = { ...this.state, asideOpen: this._asideOpen };
      sessionStorage.setItem('AppStateStorage', CryptoAES.encrypt(JSON.stringify(stateToSave), encKey));
    };
    if (window.requestIdleCallback) {
      window.requestIdleCallback(doEncrypt, { timeout: 2000 });
    } else {
      setTimeout(doEncrypt, 0);
    }
  }, 500);

  setStateAndSession = (newStateKeys) => {
    return new Promise((resolve) => {
      this.setState(newStateKeys, () => {
        this.persistToSession();
        resolve();
      });
    });
  }

  // Synchronous state update for UI actions that need immediate visual feedback.
  // In React 19, setState is batched/deferred by default. flushSync forces
  // the DOM to update in the same tick, restoring React 16 behavior for clicks.
  setStateImmediate = (newStateKeys) => {
    flushSync(() => {
      this.setState(newStateKeys);
    });
    this.persistToSession();
  }

  render() {
    // Keep live permissions in sync so renderWithPermissions works before sessionStorage is written.
    setLivePermissions(this.state.permissions);
    // Cache context value to prevent consumer re-renders when only _asideOpen changed (forceUpdate)
    if (this._cachedState !== this.state) {
      this._cachedContextValue = { state: this.state, handlers: this.handlers };
      this._cachedState = this.state;
    }
    return (
      <AppContext.Provider
        value={this._cachedContextValue}
      >
        <Auth0IdleTimer AuthClient={this.authClient} intervalFunction={this.interval} />
        {
          this.state.loading ? (<LoadingSpinner text="Loading app..." />) : (
            this.state.failed ? (<AppError text={this.state.failMessage} />) : (
              (this.state.selectedClient && !this.state.showClientSelection || window.location.pathname.includes("inbound")) ? (
                // formerly this was all in home layout
                <div className={classes.HomeLayout}>
                  <HomeAside
                    asideOpen={this._asideOpen}
                    toggleAside={this.handlers.toggleAside}
                  >
                    {
                      this.state.availableModules && (
                        <>
                          {
                            this.state.availableModules.map((x) => (
                              <GrpNavItem
                                activeClassName={classes.NavActive}
                                key={x.module}
                                icon={['fal', x.icon]}
                                label={x.moduleDisplayName}
                                state={this._asideOpen}
                                items={this.state.computedMenuItems?.[x.module] || []}
                                path={`/${x.module}`}
                                visibility
                              />
                            ))
                          }
                        </>
                      )
                    }
                  </HomeAside>

                  <div className={`${classes.HomeLayoutContent} ${this._asideOpen && classes.Open}`}>
                    <Routes>
                      <Route path="/" element={
                        <div
                          style={
                            { display: 'flex', flexGrow: '1' }
                          }
                        >
                          <div style={{ margin: 'auto', width: '75%', textAlign: 'center' }}>
                            <div>
                              <div>
                                <HomeScreenHeader>
                                  {'Welcome to ArcRegulatory'}
                                  {this.state.userGivenName && (`, ${this.state.userGivenName}`)}
                                </HomeScreenHeader>
                              </div>
                              <div>
                                <h3>Version 1.1</h3>
                              </div>
                            </div>
                          </div>
                        </div>
                      } />
                      {
                        this.state.availableModules && this.state.availableModules.map((x) => (
                          <Route key={x.module} path={`/${x.module}/*`} element={
                            isOutboundModule(x.module)
                              ? <Outbound />
                              : (
                                <HomeContent
                                  moduleName={x.module}
                                  displayName={x.moduleDisplayName}
                                  availableRoutes={this.state.availableRoutes}
                                  selectedReportingDate={this.state.selectedReportingDate}
                                />
                              )
                          } />
                        ))
                      }
                      <Route path="/callback" element={<Callback redirectURL={this.state.callbackURL + "?callback"} />} />
                      <Route path="/outbound/*" element={<Outbound />} />
                      <Route path="/inbound/*" element={<Inbound />} />
                    </Routes>
                  </div>

                  <HomeDrawer
                    title={this.state.drawerTitle}
                    visible={this.state.drawerOpen}
                    toggleDrawer={this.toggleDrawer}
                  >
                    {this.state.drawerContent && this.state.drawerContent}
                  </HomeDrawer>

                  <Toaster
                    toast={this.state.toast}
                    handler={this.closeToast}
                  />
                  {
                    this.state.modalOpen && (
                      <AppModal
                        body={this.state.modalContent}
                        bodyOverflow={this.state.modalContentOverflow}
                        footer={this.state.modalFooter}
                        handler={this.toggleModal}
                        spinner={this.state.modalSpinner}
                        title={this.state.modalTitle}
                        width={this.state.modalWidth}
                      />
                    )
                  }
                </div>
              ) : <ModalClientSelection />
            )
          )
        }
      </AppContext.Provider>
    );
  }
}

export default App;
